export const ROI_POINT_CREATE = 'ROI_POINT_CREATE';
export const ROI_POINT_DELETE = 'ROI_POINT_DELETE';
export const ROI_POINT_EDIT = 'ROI_POINT_EDIT';
export const ROI_POINT_EDIT_MANY = 'ROI_POINT_EDIT_MANY';
export const ROI_POINT_CLEAR_ALL = 'ROI_POINT_CLEAR_ALL';
export const ROI_POINT_CREATE_MANY = 'ROI_POINT_CREATE_MANY';
export const ROI_POINT_ACTIVE_SET = 'ROI_POINT_ACTIVE_SET';


